


function initPopups(){

	var popupContainer = $('.popup-wrapper');

	$(document).on('click', '.js__popup, .button', function (event) {

		var targetPopup = $(this).data('popup');
		console.log(targetPopup)

		if(targetPopup > ''){

			event.preventDefault();

			popupContainer.addClass('active');
			$('#'+targetPopup).addClass('active');
			console.log($('#'+targetPopup))
			$('body').addClass('popup-active');

			//Popup Conditional JS
			if(targetPopup == 'newsletter'){
				$('#newsletter-email').val( $('#temp-email').val() );
			}

			return false; //Double deactivate link

		}

	});



	$('.js__popup-close').click(function(event){
		event.preventDefault();
		popupContainer.removeClass('active');
		$('.popup').removeClass('active');
		$('body').removeClass('popup-active');
	});






	//Logic for the Geolocation popup !
	$.ajax({
		url: '/wp-content/themes/rhubarb-duplo/library/php/fetch-geoIP.php',
		type: 'POST',
		dataType: "json",
		data: { current_post_id : $('body').data('page-id')},
		success: function(data) {
			console.log(data);

			if(data.IsTranslation){	

				//Add relevent data to Geo IP popup
				$('.js__country-name').html(data.UserCountry);
				$('.js__country-url').attr('href',data.TranslationURL);

				//Display Geo IP popup
				// popupContainer.addClass('active');
				// $('#geo-ip').addClass('active');
				// $('body').addClass('popup-active');



			}else{
				//No traslation exists for this page in the users language
			}

		},
		error: function(xhr, textStatus, errorThrown){
       		console.log('Could not perform user locatino check');
    	}
	});





}